import React from 'react'
import {useState} from 'react'
import Button from '@components/Button'
import Loading from '@components/SuspenseLoading/Loading'
import {getStoresZones_cached_stores} from '@data/queries/components/__generated__/getStoresZones_cached'
import {deliveryZonesQuery} from '@data/queries/components/deliveryZone'
import isServerSide from '@helpers/misc/isServerSide'
import getPathname from '@helpers/router/getPathname'
import useWebsiteId from '@hooks/useWebsiteId'
import Container from '@packages/justo-parts/lib/components/Container'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import flattenDeep from 'lodash/flattenDeep'
import {useRouter} from 'next/router'

import Leaflet from './Leaflet'

import styles from './styles.module.css'

export interface DeliveryZoneProps {
  stores: any
  color: string
  icon: any
  ssrStores?: getStoresZones_cached_stores
}

export default function DeliveryZone(props: DeliveryZoneProps) {
  const router = useRouter()
  const [show, setShow] = useState(!['/', '/pedir', '/checkout'].includes(getPathname(router)))
  const websiteId = useWebsiteId()

  const {stores: queriedStores} = useQuery({
    query: deliveryZonesQuery,
    variables: {websiteId},
    omit: isServerSide(),
    partial: true
  })

  const stores = queriedStores ? queriedStores : props.ssrStores
  if (isServerSide() && !props.ssrStores) {
    console.warn(
      'Could not fetch stores while doing SSR. This should be fixed for an optimized experience'
    )
    return <Loading />
  }

  const getStores = () => {
    if (!stores) return []
    return stores.items
      .filter(store => store.acceptDelivery)
      .filter(store => store.address && store.address.location)
  }
  const getPoints = (): {lat: number; lng: number}[] => {
    return flattenDeep(getStores().map(store => store.zones.map(zone => zone.deliveryLimits)))
  }

  const getCenter = () => {
    const count = getStores().length
    return getStores().reduce(
      (last, store) => {
        const lat = store.address.location.lat / count
        const lng = store.address.location.lng / count
        return {lat: last.lat + lat, lng: last.lng + lng}
      },
      {lat: 0, lng: 0}
    )
  }

  if (!stores) return null
  if (!getStores().length) return null

  const mapProps = {
    iconURL: props.icon,
    color: props.color,
    center: getCenter(),
    getStores,
    getPoints
  }

  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.title}>Cobertura del despacho</div>
        {show ? (
          <Leaflet {...mapProps} />
        ) : (
          <Button onClick={() => setShow(true)}>Mostrar mapa</Button>
        )}
      </Container>
    </div>
  )
}
